module.exports = __webpack_public_path__ + "media/images/fp_congratulations-579cf786b15032760b5108b9477eeb2d.png";